var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-wrapper"},[_c('div',{staticClass:"loading-indicator",style:({
      height: _vm.size + 'px',
      marginBottom: _vm.margin + 'px',
      marginTop: _vm.margin + 'px',
      width: _vm.size + 'px'
    }),attrs:{"aria-live":"assertive","aria-label":"Vänta, informationen laddas..."}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23e902f4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AfSpinner.vue
// module id = 635
// module chunks = 1